import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import Swal from 'sweetalert2';

export class AssetTab extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.projectId !== this.props.projectId) {
      this.props.actions.loadProjectAssets({
        projectId: nextProps.projectId,
        version: nextProps.version,
      });
    }
    return true;
  }

  handleDelete = (uuid) => {
    const { projectId, version, actions } = this.props;
    //TODO: Refactor
    Swal.fire({
      text: "You won't be able to revert this.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d30b0b',
      cancelButtonColor: '#757f91',
      confirmButtonText: 'Yes, delete it!',
      showLoaderOnConfirm: true,
      preConfirm: () => {
        actions.deleteAsset({ projectId, version, assetId: uuid });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((_result) => {
      let tabcontent = document.getElementById('ASSETS');
      tabcontent.classList.add('selected');
    });
  };

  selectImageToUpload = (imageId) => {
    if (this.state.selectedImageId !== imageId) {
      this.setState({
        selectedImageId: imageId,
      });
    }
  };

  showAssets = () => {
    const { assets } = this.props.editor;
    if (assets.length > 0) {
      return (
        <div className="gjs-pn-panel height35 width100 position-relative">
          <div className="row px-3">
            {assets.map((asset) => (
              <div className="col-6 mb-1 asset-delete-list" key={asset.uuid}>
                <img
                  src={`${process.env.REACT_APP_S3_URL}${asset.key}`}
                  className="asset-img img-fluid"
                />
                <i
                  className="btn-xs wb webconnect-trash-solid"
                  onClick={() => this.handleDelete(asset.uuid)}
                ></i>
              </div>
            ))}
          </div>
        </div>
      );
    }
  };

  render() {
    const { isReadOnly } = this.props;
    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Assets" className="padding-left-20">
              Assets
            </span>
            <span
              title={isReadOnly ? 'Read-only mode' : 'Add'}
              className="gjs-pn-btn"
              style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
            >
              &nbsp;
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip={isReadOnly ? 'Read-only mode' : 'Add Asset'}
                data-place="bottom"
                data-effect="solid"
                onClick={() => {
                  if (isReadOnly) return;
                  this.props.actions.toggleAssetUplod();
                }}
                style={{
                  opacity: isReadOnly ? 0.5 : 1,
                  cursor: isReadOnly ? 'not-allowed' : 'pointer',
                }}
              >
                <i className="wb webconnect-plus"></i>&nbsp;Add
              </a>
            </span>
            <span title="Search Image" className="">
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip="Search"
                data-place="bottom"
                data-effect="solid"
                onClick={() => {
                  this.props.actions.toggleAssetSearch();
                }}
              >
                <i className="wb webconnect-search"></i>&nbsp; Search Image
              </a>
            </span>
          </div>
        </div>
        {this.showAssets()}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetTab);
